import { AccountModal } from '@ui/components/AccountModal';
import { FaqModal } from '@ui/components/Faq';
import { NftClaimDrawer, NftDetailDrawer } from '@ui/components/NFTCard';
import { VaultDetailDrawer } from '@ui/views/Vno/ReservoirAndFountain';
import NextProgress from 'nextjs-progressbar';

import { AnnouncementDrawer } from './AnnouncementPopover';
import { useAnnouncementPopover } from './AnnouncementPopover/useAnnouncementPopover';
import { DisclaimerDrawer, useDisclaimerDrawer } from './DisclaimerDrawer';
import Features from './Features';
import { LangModal, useLangModal } from './LangMenu';
import { LazyComponent } from './LazyComponent';
import { RenderInMobile } from './MobileOrDesktop';
import { TopNavMenuDrawer, useTopNavMenuDrawer } from './TopNavMenuDrawer';
import { StakingTour } from './Tours';
import {
  TransactionDetailDrawer,
  TransactionHistoryDrawer,
} from './TransactionHistoryDrawer';
import { TransakModal } from './TransakModal';
import { WalletModal } from './Wallet';

export const GlobalComponents = () => {
  const isAnnouncementOpen = useAnnouncementPopover((s) => s.isOpen);
  const isDisclaimerDrawerOpen = useDisclaimerDrawer((s) => s.isOpen);
  const isTopNavMenuDrawerOpen = useTopNavMenuDrawer((s) => s.isOpen);
  const isLangModalOpen = useLangModal((s) => s.isOpen);

  return (
    <>
      <NextProgress />
      <WalletModal />
      <AccountModal />
      <VaultDetailDrawer />
      <FaqModal />
      <NftDetailDrawer />
      <NftClaimDrawer />
      <TransactionHistoryDrawer />
      <TransactionDetailDrawer />
      <TransakModal />
      <LazyComponent isOpen={isAnnouncementOpen}>
        <RenderInMobile>
          <AnnouncementDrawer />
        </RenderInMobile>
      </LazyComponent>
      <LazyComponent isOpen={isDisclaimerDrawerOpen}>
        <DisclaimerDrawer />
      </LazyComponent>
      <Features.stakingTour>
        <StakingTour />
      </Features.stakingTour>
      <LazyComponent isOpen={isTopNavMenuDrawerOpen}>
        <RenderInMobile>
          <TopNavMenuDrawer />
        </RenderInMobile>
      </LazyComponent>
      <LazyComponent isOpen={isLangModalOpen}>
        <RenderInMobile>
          <LangModal />
        </RenderInMobile>
      </LazyComponent>
    </>
  );
};
